import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import BusinessIcon from '@mui/icons-material/Business';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import FlagIcon from '@mui/icons-material/Flag';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

export default function BurgerMenuPage() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation(); 
  const { user, isAdmin, isManager, isRestrictedUser, logout } = useAuth();



  // Função para voltar à página anterior
  const handleGoBack = () => {
    navigate(-1); // Volta para a página anterior no histórico
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const handleExit = () => {
    logout();
    navigate('/');
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Navbar */}
      <AppBar position="static" sx={{ backgroundColor: '#3FA5D4' }}>
        <Toolbar>
          {/* Botão do menu burger - lado esquerdo */}
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 1 }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>

          {/* Botão de voltar - aparece apenas quando apropriado */}
          { (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="go back"
              sx={{ mr: 1 }}
              onClick={handleGoBack}
            >
              <ArrowBackIcon />
            </IconButton>
          )}

          {/* Título centralizado */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Hub4Food<sup>®</sup>
          </Typography>

          {/* Ícone do perfil - lado direito */}
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => handleNavigation('/usersettings')}>Profile</MenuItem>
              <MenuItem onClick={handleExit}>Exit</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      {/* Drawer Menu - Burger Menu */}
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={handleDrawerToggle}
        sx={{ width: 240, flexShrink: 0 }}
      >
        <Box sx={{ width: 240, display: 'flex', flexDirection: 'column' }}>
          {/* Logo no Drawer */}
          <Box sx={{ padding: 2, textAlign: 'center' }}>
            <img 
              src="logocolab.png" 
              alt="Hub4Food Logo" 
              style={{ width: '80%', maxWidth: '120px' }} 
            />
          </Box>

          {/* Linha Divisória */}
          <Divider sx={{ marginTop: 1 }} />

          <List>
            {/* Restricted user menu items */}
            {isRestrictedUser ? (
              <ListItem button onClick={() => handleNavigation('/listIdea')}>
                <LightbulbIcon sx={{ marginRight: 2 }} />
                <ListItemText primary="List Ideas" />
              </ListItem>
            ) : (
              <>
                {/* Items for non-restricted users */}
                <ListItem button onClick={() => handleNavigation('/entities')}>
                  <BusinessIcon sx={{ marginRight: 2 }} />
                  <ListItemText primary="Entities" />
                </ListItem>
                <ListItem button onClick={() => handleNavigation('/ideationPlatform')}>
                  <LightbulbIcon sx={{ marginRight: 2 }} />
                  <ListItemText primary="Ideation Platform" />
                </ListItem>
                <ListItem button onClick={() => handleNavigation('/contacts')}>
                  <ContactMailIcon sx={{ marginRight: 2 }} />
                  <ListItemText primary="Contacts" />
                </ListItem>

                {/* Show Actions only for admin and manager */}
                {(isAdmin() || isManager()) && (
                  <ListItem button onClick={() => handleNavigation('/listentities')}>
                    <FlagIcon sx={{ marginRight: 2 }} />
                    <ListItemText primary="Actions" />
                  </ListItem>
                )}

                {/* Show Admin only for admin */}
                {isAdmin() && (
                  <ListItem button onClick={() => handleNavigation('/admin')}>
                    <AdminPanelSettingsIcon sx={{ marginRight: 2 }} />
                    <ListItemText primary="Admin" />
                  </ListItem>
                )}
              </>
            )}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}